export default __webpack_public_path__ + "static/media/konsep_2.b6c9ed8a.jpg";